// ============================================================
// HABIT OS — English Translations
// ============================================================

export const en = {
  // ── APP ──────────────────────────────────
  app_name: "Habit OS",

  // ── NAVIGATION ───────────────────────────
  nav_today:    "Today",
  nav_coach:    "Coach",
  nav_insights: "Insights",
  nav_discover: "Discover",

  // ── GREETING ─────────────────────────────
  greeting_morning:   "Good morning",
  greeting_afternoon: "Good afternoon",
  greeting_evening:   "Good evening",
  greeting_subtitle:  "Set the anchor for your day.",

  // ── TODAY TAB ────────────────────────────
  today_progress:        "Today",
  today_streak:          "Days",
  today_last7:           "Last 7 days",
  today_freeze_title:    "Streak Freezes",
  today_freeze_subtitle: "Earned by completing all morning habits",
  today_protocol:        "Protocol",
  today_morning:         "Morning",
  today_morning_routine: "Morning Routine",
  today_night:           "Evening",
  today_night_routine:   "Night Routine",
  today_add_habit:       "+ Add habit",
  today_search_habit:    "Search or type a habit…",
  today_add_btn:         "Add",
  today_from_library:    "Choose from library",
  today_more_library:    "Discover more in the library →",
  today_freeze_earned:   "Freeze earned ❄️",
  today_hero_badge:      "HERO",
  today_pro_badge:       "PRO",
  today_calendar_legend_complete: "Complete",
  today_calendar_legend_freeze:   "Freeze",
  today_calendar_legend_grace:    "Grace",
  today_calendar_legend_missed:   "Missed",

  // ── INSIGHTS TAB ─────────────────────────
  insights_title:         "Your Progress",
  insights_subtitle:      "Last 30 days",
  insights_active_days:   "active days",
  insights_completion:    "Completion",
  insights_best_streak:   "Best Streak",
  insights_habits_done:   "Habits done",
  insights_this_week:     "This week",
  insights_strongest:     "Strongest Habit",
  insights_best_day:      "Best Day",
  insights_most_completions: "Most completions",
  insights_ranking:       "Habit Ranking · 30 days",
  insights_more_habits:   "more habits",
  insights_improvement:   "Room for improvement",
  insights_no_data_title: "No data yet",
  insights_no_data_text:  "Check off your first habits — your statistics will appear after a few days.",
  insights_loading:       "Loading statistics…",
  insights_times_done:    "× done",
  insights_improvement_text: "is only completed {rate}% of the time. Consider adjusting the timing or effort required.",

  // ── DISCOVER TAB ─────────────────────────
  discover_title:    "Library",
  discover_subtitle: "Discover new habits",
  discover_add:      "Add",
  discover_added:    "Added ✓",
  discover_why:      "Why?",
  discover_dose:     "Dosage",
  discover_source:   "Sources",
  discover_morning:  "Morning",
  discover_night:    "Evening",

  // ── AGENT / COACH ─────────────────────────
  agent_ready:          "is ready",
  agent_typing:         "Write something…",
  agent_send:           "Send",
  agent_change:         "switch ›",
  agent_proactive:      "Proactive",
  agent_weekly_review:  "Weekly Review",
  agent_suggestion:     "Recommendation",
  agent_options_review: "Weekly Review",
  agent_options_change: "Switch companion",
  agent_options_clear:  "Clear history",
  agent_choose:         "Choose your companion",
  agent_active:         "ACTIVE",
  agent_loading:        "Preparing your companion…",
  agent_error:          "I couldn't reach you right now. Please try again.",

  // ── PROFILE SHEET ────────────────────────
  profile_progress:       "Your Progress",
  profile_streak:         "Streak",
  profile_freezes:        "Freezes",
  profile_plan:           "Plan",
  profile_plan_free:      "Free",
  profile_plan_pro:       "Pro",
  profile_section_profil: "Profile",
  profile_change_name:    "Change name",
  profile_email:          "Email",
  profile_section_notifications: "Notifications",
  profile_push_active:    "Active — reminders will be sent",
  profile_push_inactive:  "Inactive",
  profile_push_denied:    "Blocked in browser settings",
  profile_push_unsupported: "Not supported in this browser",
  profile_morning_reminder: "☀️ Morning Reminder",
  profile_night_reminder:   "🌙 Night Reminder",
  profile_push_info:      "Notifications are sent in your local timezone. Changes are saved automatically.",
  profile_section_settings: "Settings",
  profile_dark_mode:      "Dark Mode",
  profile_dark_active:    "Dark theme active",
  profile_light_active:   "Light theme active",
  profile_language:       "Language",
  profile_section_account: "Account",
  profile_upgrade:        "Upgrade to Pro",
  profile_change_password: "Change password",
  profile_sign_out:       "Sign out",
  profile_delete_account: "Delete account",
  profile_save:           "Save",
  profile_saving:         "Saving…",
  profile_password_min:   "At least 8 characters.",
  profile_password_mismatch: "Passwords don't match.",
  profile_password_changed: "Password changed.",
  profile_name_saved:     "Name saved.",
  profile_delete_warning: "This action is irreversible. All your data will be permanently deleted.",
  profile_delete_confirm: "Type DELETE to confirm:",
  profile_delete_input:   "DELETE",
  profile_delete_btn:     "Permanently delete account",
  profile_deleting:       "Deleting…",
  profile_push_enabled:   "Push notifications enabled! ✓",
  profile_push_disabled:  "Push notifications disabled.",
  profile_push_denied_msg: "Permission denied. Please enable in browser settings.",

  // ── ONBOARDING ───────────────────────────
  onboarding_goal_title:    "What is your\nmost important goal?",
  onboarding_goal_subtitle: "Choose a focus — you can change it anytime.",
  onboarding_protocol_title: "Choose your role model",
  onboarding_recommended:   "Recommended",
  onboarding_more:          "More role models",
  onboarding_no_rolemodel:  "Start without a role model → Neuro-Optimizer",
  onboarding_ready_title:   "All set.",
  onboarding_morning_habits: "Morning habits",
  onboarding_night_habits:   "Night habits",
  onboarding_start:         "Start now 🚀",
  onboarding_next:          "Next →",
  onboarding_back:          "←",
  onboarding_skip:          "Skip",

  // ── ROUTINE SELECTOR ─────────────────────
  routine_choose:   "Choose protocol",
  routine_active:   "ACTIVE",
  routine_morning:  "☀️",
  routine_night:    "🌙",

  // ── ERRORS & STATES ──────────────────────
  loading:          "Loading…",
  loading_routines: "Loading your routines…",

  // ── PWA INSTALL ──────────────────────────
  pwa_install_title:    "Install Habit OS",
  pwa_install_subtitle: "Open directly from your home screen",
  pwa_later:            "Later",
  pwa_install:          "Install",
  pwa_guide_title:      "Install app",
  pwa_guide_subtitle:   "Add to home screen",
  pwa_step1: "Tap the share icon at the bottom of Safari",
  pwa_step2: "Select \"Add to Home Screen\"",
  pwa_step3: "Tap \"Add\" — done!",
  pwa_guide_btn: "Guide",
};
